/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const ADD_BOUNDING_BOX_TO_ANNOTATED_IMAGE = gql`
  mutation AddBoundingBoxToAnnotatedImage(
    $imageId: ID!
    $minX: Float!
    $maxX: Float!
    $minY: Float!
    $maxY: Float!
    $metaClass: MetaClass!
    $tagId: ID
  ) {
    addBoundingBoxToAnnotatedImage(
      imageId: $imageId
      minX: $minX
      maxX: $maxX
      minY: $minY
      maxY: $maxY
      metaClass: $metaClass
      tagId: $tagId
    ) {
      __typename
      ... on AddBoundingBoxResult {
        boundingBox {
          id
          sourceImageUrl
          minX
          maxX
          minY
          maxY
          metaClass
          tag
          tagId
          isHumanAdded
          isHumanDeleted
          leasedById
          leasedAt
        }
      }
      ... on OperationInfo {
        messages {
          kind
          message
          field
          code
        }
      }
    }
  }
`
